import { Dispatch } from "redux";
import { camelize } from "../../config/functions";
import {
  getAllSalaries,
  getSalaryById,
  createSalary,
  updateSalary,
  deleteSalary,
} from "../../services/salaryMasterService";
import { SalaryMaster } from "../../types/salaryMaster";

export enum SalaryMasterActionList {
  ADD_SALARYMASTER = "ADD_SALARYMASTER",
  EDIT_SALARYMASTER = "EDIT_SALARYMASTER",
  FETCH_SALARYMASTER = "FETCH_SALARYMASTER",
  FETCH_SALARYMASTERBYID = "FETCH_SALARYMASTERBYID",
  DELETE_SALARYMASTER = "DELETE_SALARYMASTER",
}

export interface AddSalaryAction {
  type: SalaryMasterActionList.ADD_SALARYMASTER;
  data: SalaryMaster;
}

export interface EditSalaryAction {
  type: SalaryMasterActionList.EDIT_SALARYMASTER;
  data: SalaryMaster;
  id: number;
}

export interface FetchSalaryAction {
  type: SalaryMasterActionList.FETCH_SALARYMASTER;
  data: SalaryMaster[];
}
export interface FetchSalaryByIdAction {
  type: SalaryMasterActionList.FETCH_SALARYMASTERBYID;
  data: SalaryMaster[];
}

export interface DeleteSalaryAction {
  type: SalaryMasterActionList.DELETE_SALARYMASTER;
  data: number;
}

export type SalaryMasterActions =
  | AddSalaryAction
  | EditSalaryAction
  | FetchSalaryAction
  | DeleteSalaryAction
  | FetchSalaryByIdAction;

export const addSalaryMasterAction = (data: SalaryMaster) => {
  return async (dispatch: Dispatch) => {
    return createSalary(data)
      .then((res) => {
        if (res.status === 200 && res.data.data) {
          dispatch<AddSalaryAction>({
            type: SalaryMasterActionList.ADD_SALARYMASTER,
            data: res.data,
          });

          return Promise.resolve(res.data.message ?? "Salary Master added");
        } else {
          throw new Error(res.data?.message ?? "unable to Salary Master added");
        }
      })
      .catch((error) =>
        Promise.reject(error.res?.data?.message ?? "Salary Master deleted"),
      );
  };
};

export const editSalaryMasterAction = (id: number, data: SalaryMaster) => {
  return async (dispatch: Dispatch) => {
    return updateSalary(id, data)
      .then((res) => {
        if (res.status === 200 && res.data) {
          dispatch<EditSalaryAction>({
            type: SalaryMasterActionList.EDIT_SALARYMASTER,
            data: res.data,
            id,
          });
          return Promise.resolve(res.data.message ?? "Salary Master updated");
        } else {
          throw new Error(
            res.data?.message ?? "unable to Salary Master updated",
          );
        }
      })
      .catch((error) =>
        Promise.reject(error.res?.data?.message ?? "Salary Master deleted"),
      );
  };
};

export const fetchSalariesMasterAction = () => {
  return async (dispatch: Dispatch) => {
    const res = await getAllSalaries();
    dispatch<FetchSalaryAction>({
      type: SalaryMasterActionList.FETCH_SALARYMASTER,
      data: res,
    });
  };
};
export const fetchSalariesMasterActionBYID = (employeeId: String) => {
  return async (dispatch: Dispatch) => {
    const res = await getSalaryById(employeeId);
    console.log(res);
    const salaryData = res.data.data.find(
      (item: any) => item.employeeId === employeeId,
    );
    console.log(salaryData);

    dispatch<FetchSalaryByIdAction>({
      type: SalaryMasterActionList.FETCH_SALARYMASTERBYID,
      data: salaryData,
    });
  };
};

export const deleteSalaryMasterAction = (id: number) => {
  return async (dispatch: Dispatch) => {
    return deleteSalary(id)
      .then((response) => {
        if (response.status === 200) {
          dispatch<DeleteSalaryAction>({
            type: SalaryMasterActionList.DELETE_SALARYMASTER,
            data: id,
          });
          return Promise.resolve(
            response.data.message ?? "Salary Master deleted",
          );
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "unable to delete salary master",
        ),
      );
  };
};
